import { render, staticRenderFns } from "./AppSettingCPModalAdd.vue?vue&type=template&id=5c504dac"
import script from "./AppSettingCPModalAdd.vue?vue&type=script&lang=js"
export * from "./AppSettingCPModalAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports